import { Link } from "react-router-dom";
import { CheckCircle2, CircleAlert, ArrowRight } from "lucide-react";
import { useFetch } from "../lib/api";
import { useMember } from "../lib/member";

const Bar = ({ pct }) => (
  <div className="h-1.5 w-full rounded-full bg-[#1F2A3E] overflow-hidden"><div className={`h-full ${pct === 100 ? "bg-emerald-400" : pct >= 60 ? "bg-amber-400" : "bg-rose-400"}`} style={{ width: `${pct}%` }} /></div>);

export const OrgChecklist = ({ data }) => (
  <div className="c-surface p-5 grid gap-3" data-testid="org-checklist">
    <div className="flex items-center justify-between gap-3">
      <div className="c-eyebrow">Details checklist</div>
      <span className="font-mono text-xs text-slate-300" data-testid="org-checklist-pct">{data.complete_pct}% complete</span>
    </div>
    <Bar pct={data.complete_pct} />
    {data.missing.length ? (
      <div className="flex flex-wrap gap-2">{data.missing.map((m) => (
        <span key={m.key} className="inline-flex items-center gap-1 rounded-full border border-amber-500/30 bg-amber-500/5 px-2.5 py-1 text-xs text-amber-100" data-testid={`org-missing-${m.key}`}>
          <CircleAlert size={12} className="text-amber-300" />{m.label}</span>))}</div>
    ) : <div className="flex items-center gap-1.5 text-sm text-emerald-300" data-testid="org-checklist-done"><CheckCircle2 size={15} />All details are filled in.</div>}
  </div>);

const MyCard = () => {
  const { data } = useFetch("/org/profile");
  if (!data || !data.missing.length) return null;
  return (
    <Link to="/organisation" className="mt-6 mb-6 c-surface p-5 c-rise grid md:grid-cols-[1fr_auto] gap-3 items-center hover:!border-[#00E599]/40 transition-colors" data-testid="dashboard-org-checklist">
      <div className="grid gap-2"><div className="c-eyebrow">Complete your organisation details · {data.complete_pct}%</div><Bar pct={data.complete_pct} />
        <div className="text-xs text-slate-400">Missing: {data.missing.map((m) => m.label).join(", ")}</div></div>
      <span className="text-xs text-slate-300 flex items-center gap-1">Fill in now <ArrowRight size={13} /></span>
    </Link>);
};

const TeamCard = () => {
  const { data } = useFetch("/org/checklist");
  const open = (data || []).filter((x) => x.missing.length);
  if (!open.length) return null;
  return (
    <div className="mt-6 mb-6 c-surface p-5 c-rise" data-testid="dashboard-org-checklist">
      <div className="flex items-center justify-between mb-3"><div className="c-eyebrow">Organisation details still missing</div>
        <Link to="/settings?tab=organisation" className="text-xs text-slate-400 hover:text-white">Open settings →</Link></div>
      <div className="grid gap-2.5">{open.slice(0, 6).map((x) => (
        <Link key={x.id} to={`/settings?tab=organisation&org=${x.kind}:${x.id}`} className="grid sm:grid-cols-[220px_120px_1fr] gap-x-4 gap-y-1 items-center rounded-md px-2 py-1.5 hover:bg-[#1A2234]" data-testid="org-checklist-row">
          <span className="text-sm truncate">{x.name} <span className="text-[10px] text-slate-500 uppercase">{x.kind === "employer" ? "PE" : "contractor"}</span></span>
          <Bar pct={x.complete_pct} />
          <span className="text-xs text-slate-400 truncate">{x.missing.map((m) => m.label).join(", ")}</span>
        </Link>))}</div>
    </div>);
};

export const OrgChecklistCard = () => {
  const { me } = useMember();
  if (!me?.role) return null;
  return ["employer", "vendor"].includes(me.role) ? <MyCard /> : <TeamCard />;
};
